export default __webpack_public_path__ + "static/media/Venus.397fdee2.png";